<template>
  <div>
    <PageLoader
      v-if="loadingMemberships"
      message="Loading Membership Programs..."
    />
    <div v-for="mp in membershipPrograms" :key="mp.id">
      <MembershipProgramCard :membership-program="mp" class="mb-4" />
    </div>
    <div
      v-if="!membershipPrograms.length && !loadingMemberships"
      class="no-results-message"
    >
      <i class="fad fa-question-circle"></i>
      No Memberships Available
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import PageLoader from "@/components/PageLoader.vue";
import MembershipProgramCard from "./MembershipProgramCard.vue";

export default {
  components: {
    MembershipProgramCard,
    PageLoader
  },
  props: {
    active: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadingMemberships: true
    };
  },
  computed: {
    ...mapState({
      membershipPrograms: function ({ membershipPrograms }) {
        if (this.active) {
          return membershipPrograms.filter((mp) => mp.is_active);
        }
        return membershipPrograms;
      }
    })
  },
  mounted() {
    this.fetchMembershipPrograms().finally(
      () => (this.loadingMemberships = false)
    );
  },
  methods: {
    ...mapActions(["fetchMembershipPrograms"])
  }
};
</script>

<style lang="scss" scoped></style>
